import Attrs from '../models/Attrs'
import type { Rive } from '../models/types'

const CONTROLLER = 'components--rive'
export default function renderRive(component: Rive, attrs: Attrs): string {
  attrs.addController(CONTROLLER).addValueIfExists(CONTROLLER, 'src', component?.src)
  return `<canvas ${attrs.toString()}></canvas>`
}
